<template>
    <steps-option
        @updateNavigation="updateNavigation"
        :noColors="true"
    />
</template>

<script>
    import StepsOption from './StepsOption.vue';

    export default {
        components: {
            StepsOption,
        },

        beforeDestroy() {
            this.getSnapshot();
        },

        methods: {
            updateNavigation(navRules) {
                // There should always be the next group because Pets step move.
                this.$emit('updateNavigation', navRules);
            },

            async getSnapshot() {
                const popSnapshot = await this.$store.dispatch('snapshot', 'SnapshotPop');

                this.$store.dispatch('setCartImageByController', popSnapshot);
            },
        },
    };
</script>
